<template>
    <div class="g-content admire">
        <div class="content-manage">
            <div class="list">
                <div class="list-item">
                    <img :src="taskInfo.gameLogo" alt="" class="list-img" style="width: 67px;height:67px;" />
                    <div class="list-content">
                        <div class="title">
                            <a href="javascript:;">{{ taskInfo.title }}</a>
                        </div>
                        <div class="info">
                            <div>
                                <span class="task-price">{{
                  Number(taskInfo.cpa).toFixed(2)
                }}</span>元
                                <span class="task-tag">CPA</span>

                                <i class="ico ico-time"></i>
                                <span>{{ taskInfo.startTime }} ~ {{ taskInfo.endTime }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="main-content">
                <!-- 第一步 -->
                <el-steps :active="step" align-center finish-status="success">
                    <el-step title="选择模板"></el-step>
                    <!-- <el-step title="编辑页面"></el-step> -->
                    <el-step title="提交"></el-step>
                </el-steps>
                <div class="line"></div>
                <div class="first-step" v-show="step == 0">
                    <div>
                        <el-row :gutter="20">
                            <el-col :span="6" v-for="(item, index) in taskInfo.template" :key="index"
                                style="margin-bottom: 20px;">
                                <el-card class="card-item" shadow="hover" :body-style="{ padding: '0px' }">
                                    <el-radio class="select-radio" v-model="params.templateId"
                                        :label="item.templateId" @change="changeTemplate(item.templateId)">
                                        <div class="card-top">
                                            {{ item.templateName }}
                                        </div>
                                        <img :src="
                        item.templateCover ||
                          'https://shadow.elemecdn.com/app/element/hamburger.9cf7b091-55e9-11e9-a976-7f4d0b07eef6.png'
                      " class="type-pic" />
                                    </el-radio>
                                </el-card>
                            </el-col>
                        </el-row>
                        <div class="btn-wrap">
                            <a href="javascript:;" class="button" @click="next">下一步</a>
                        </div>
                    </div>
                </div>
                <!-- 第二步 -->
                <div class="second-step" v-show="step == 3">
                    <el-row :gutter="20">
                        <el-col :span="7" :offset="1">
                            <div class="card-item card-item-box">
                                <div class="card-top">
                                    海报模板
                                </div>
                                <img src="https://shadow.elemecdn.com/app/element/hamburger.9cf7b091-55e9-11e9-a976-7f4d0b07eef6.png"
                                    class="type-pic" />
                            </div>
                        </el-col>
                        <el-col :span="16">
                            <div class="second-top">
                                <div>
                                    选择图文：
                                    <el-input type="text" class="select-input" v-model="params.articleId">
                                    </el-input>
                                </div>
                                <a href="javascript:;" class="button" @click="next">获取</a>
                            </div>
                            <div class="second-desc"></div>
                        </el-col>
                    </el-row>
                    <div class="btn-wrap">
                        <a href="javascript:;" class="button" @click="prev">上一步</a>
                        <a href="javascript:;" class="button" @click="next">下一步</a>
                    </div>
                </div>
                <!-- step3 -->
                <div class="third-step" v-show="step == 1">
                    <el-form label-width="120px">
                        <el-form-item label="昵称" required>
                            <el-input v-model="params.userName" placeholder="请填写昵称"></el-input>
                        </el-form-item>
                        <el-form-item label="渠道说明" required>
                            <el-input type="textarea" v-model="params.channelDesc" :rows="5" resize="none"
                                placeholder="不少于15字，说明投放渠道，用户群信息等"></el-input>
                        </el-form-item>
                        <el-form-item label="预计曝光量" required>
                            <el-input type="number" v-model.number="params.expectExposure"
                                placeholder="请填写预计曝光量"></el-input>
                        </el-form-item>
                        <el-form-item label="预计下载量" required>
                            <el-input type="number" v-model.number="params.expectDownload"
                                placeholder="请填写预计下载量"></el-input>
                        </el-form-item>
                    </el-form>
                    <div class="btn-wrap">
                        <a href="javascript:;" class="button" @click="prev">上一步</a>
                        <a href="javascript:;" class="button" @click="submit">提交</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { DownloadTaskInfo, DownloadTaskJoin } from "Services/getData.js";
export default {
    data() {
        return {
            step: 0,
            params: {
                taskId: "",
                templateId: "", //模版id	int	是	null
                templateType: "", //模版类型	int	是	null
                channelDesc: "", //投放渠道说明	string	是	null
                expectExposure: "", //预期曝光量	int	否	null
                expectDownload: "", //预期下载量	int	否	null
                userName: "", //昵称	string	否	null
                articleId: ""
            },
            selectedTemplate: {},
            taskInfo: {},
            loading: false
        };
    },
    mounted() {
        this.params.taskId = this.$route.query.id;
        this.getDownloadTaskInfo();
    },
    methods: {
        changeTemplate(templateId) {
            this.taskInfo.template.forEach(v => {
                if (v.templateId === templateId) {
                    this.selectedTemplate = v;
                }
            });
        },
        async submit() {
            if (!this.params.userName) {
                this.$message.error("昵称不能为空");
                return;
            }
            if (!this.params.channelDesc) {
                this.$message.error("渠道说明不能为空");
                return;
            }
            if (this.params.channelDesc.length < 15) {
                this.$message.error("渠道说明不能少于15字");
                return;
            }
            if (!this.params.expectExposure) {
                this.$message.error("预期曝光量不能为空");
                return;
            }
            if (!this.params.expectDownload) {
                this.$message.error("预期下载量不能为空");
                return;
            }
            this.params.templateId = this.selectedTemplate.templateId;
            this.params.templateType = this.selectedTemplate.templateType;
            if (this.loading) {
                return;
            }
            this.loading = true;
            let res = await DownloadTaskJoin(this.params);
            this.loading = false;
            if (res.status === 200 && res.data.code === 0) {
                this.$alert(
                    `
                已成功参与“${this.taskInfo.title}”，请到【我的任务】tab复制推广页面的链接&二维码，并尽快进行推广 
                <br><br> 
                单次任务页面曝光量小于${this.params.expectExposure}人次，将被处罚3个月内不能参与新的任务`,
                    "提示",
                    {
                        dangerouslyUseHTMLString: true,
                        confirmButtonText: "知道了",
                        callback: action => {
                            this.$router.push({
                                name: "v4-extension-manage",
                                query: {
                                    type: "personPage"
                                }
                            });
                        }
                        // center: true
                    }
                );
            }
        },
        prev() {
            this.step--;
        },
        next() {
            if (!this.params.templateId) {
                this.$message.error("请先选择模板");
                return;
            }
            this.step++;
        },
        async getDownloadTaskInfo(a, b, c) {
            let res = await DownloadTaskInfo({
                taskId: this.params.taskId
            });
            if (res.status === 200 && res.data.code === 0) {
                this.taskInfo = res.data.data;
                // if (this.taskInfo.joined === 1) {
                //     this.$alert("你已参加过该任务了，不能重复参加", "提示", {
                //         confirmButtonText: "确定",
                //         callback: action => {
                //             history.go(-1);
                //         }
                //     });
                // }
            }
        }
    }
};
</script>

<style lang="scss" scoped>
@import '~Assets/sass/pages/v4/admire/index.scss';
.g-content.admire {
    font-size: 14px;
    padding: 0;
    background: transparent;
    .main-content {
        padding: 30px;
        background: #fff;
    }
    .btn-wrap {
        text-align: center;
        margin-top: 40px;
    }
    .button {
        display: inline-block;
        vertical-align: top;
        width: auto;
        height: 30px;
        margin: 0 25px;
        padding: 0 30px;
        border: 1px solid #fd7e28;
        border-radius: 2px;
        line-height: 30px;
        font-size: 14px;
        color: #fd7e28;
        &:hover {
            background: #fff2e8;
        }
    }
    .line {
        height: 1px;
        background: #dcdfe6;
        width: 100%;
        margin: 15px 0 30px;
    }
    .card-item {
        padding: 20px;
        height: 248px;
        .type-pic {
            width: 153px;
            height: 218px;
        }
        /deep/ .el-radio__label {
            position: absolute;
            top: 0;
            left: 0;
            padding: 0;
        }
    }
    .card-top {
        position: relative;
        text-align: center;
        margin-bottom: 10px;
        .select-radio {
            position: absolute;
            left: 0;
            top: 3px;
        }
    }
    .content-manage {
        .list-item {
            border: 0;
            background: #fff;
            box-shadow: none;
        }
        .date {
            position: relative;
            width: 300px;
            border: none;
            border-bottom: 1px solid rgba(235, 235, 235, 1);
            border-radius: 0;
        }
        .task-price {
            font-size: 20px;
        }
        .task-tag {
            display: inline-block;
            line-height: 20px;
            padding: 0 5px;
            text-align: center;
            font-size: 14px;
            background: #fff2e8;
            color: #fd7e28;
        }
        .ico-time {
            vertical-align: -3px;
            margin-right: 5px;
            margin-left: 60px;
        }
        .list-content {
            position: relative;
        }
        .card-item-box {
            width: 153px;
        }
        .second-top {
            padding-top: 15px;
            display: flex;
            align-items: center;
            margin-bottom: 20px;
            .select-input {
                display: inline-block;
                width: 260px;
            }
        }
        .second-desc {
            width: 350px;
            height: 160px;
            background: #f9f9f9;
            border-radius: 2px;
        }
    }
}
</style>
